import { gql } from '@apollo/client';

export const getSession = gql`
  query getSession($sessionInput: GetSessionInput!) {
    getSession(input: $sessionInput) {
      altId
    }
  }
`;
